// src/components/AboutSection.jsx
import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { FaCheckCircle, FaAward, FaPhoneAlt } from "react-icons/fa";
import { motion } from "framer-motion";
import "./AboutSection.css";

import worker from "../assets/about-project.jpg"; // left side main image
import roof from "../assets/about-management-1.png"; // small overlay image

const AboutSection = () => {
  // Animation variants
  const leftVariants = {
    hidden: { opacity: 0, x: -80 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
  };

  const rightVariants = {
    hidden: { opacity: 0, x: 80 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
  };

  // Parent UL stagger
  const listVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 }, // delay each li
    },
  };

  // Each LI animation
  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
  };

  return (
    <section className="about-section py-5 position-relative">
      {/* Right Decorative SVG Shape */}
      <div className="cs_section_shape-1 position-absolute semi_rotate">
        {/* keep your existing SVG code */}
      </div>

      <Container>
        <Row className="align-items-center">
          {/* Left Side - Images */}
          <Col md={5} className="position-relative">
            <motion.div
              className="image-box"
              variants={leftVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ amount: 0.3 }} // triggers every scroll
            >
              {/* dotted pattern bg */}
              <div className="dot-pattern"></div>

              {/* main image */}
              <img src={worker} alt="worker" className="main-img" />

              {/* red vertical award box */}
              <div className="award-vertical-box">
                <h3>11+</h3>
                <p>
                  World Best <br /> Project Award Got
                </p>
                <FaAward className="award-icon" />
              </div>

              {/* small overlay image */}
              <div className="small-img-box">
                <img src={roof} alt="roof" />
              </div>
            </motion.div>
          </Col>

          {/* Right Side - Text */}
          <Col md={7}>
            <motion.div
              className="about-content"
              variants={rightVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ amount: 0.3 }} // triggers every scroll
            >
              <span className="tagline">ABOUT US</span>
              <h2>Where Strategy Powers Global Transformation</h2>
              <p>
              Strat Edge Project Management Services is a UAE-based consultancy founded by Masood, a seasoned project management specialist with over 11 years of experience delivering complex, cross-industry solutions. From digital transformation to intelligent automation, Strat Edge bridges the gap between strategy and execution — helping organizations move from vision to reality.
                <br />
                <br />
               Though based in Abu Dhabi, our reach is global. We collaborate with a network of trusted professionals and organizations to deliver tailored solutions that scale across borders.
              </p>

              {/* Features list with staggered animation */}
          <motion.ul
  className="features-list"
  variants={listVariants}
  initial="hidden"
  whileInView="visible"
  viewport={{ amount: 0.3 }} // animate each scroll
>
  <motion.li variants={itemVariants}>
    <FaCheckCircle /> Over 11+ Years of Proven Industry Experience
  </motion.li>
  <motion.li variants={itemVariants}>
    <FaCheckCircle /> Trusted Consultancy Partner for UAE Businesses & Government
  </motion.li>
  <motion.li variants={itemVariants}>
    <FaCheckCircle /> Expertise in Digital Transformation & IT Infrastructure
  </motion.li>
  <motion.li variants={itemVariants}>
    <FaCheckCircle /> Successfully Delivered 300+ Mission-Critical Projects
  </motion.li>
  <motion.li variants={itemVariants}>
    <FaCheckCircle /> Streamlined Operations & Optimized Business Processes
  </motion.li>
  <motion.li variants={itemVariants}>
    <FaCheckCircle /> Headquartered in Abu Dhabi with Global Reach
  </motion.li>
</motion.ul>


              <div className="d-flex align-items-center mt-4">
                <Button variant="danger" className="custom-btn me-3">
                  ABOUT US
                </Button>

                <div className="d-flex align-items-center">
                  <FaPhoneAlt className="phone-icon me-2" />
                  <div>
                    <small>Call Us Now</small>
                    <h6> +971 50 576 5759</h6>
                  </div>
                </div>
              </div>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutSection;
